<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'aplicativo-categorias',
  data () {
    return {
      title: 'Apps - Categorias'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/aplicativo-categorias' || this.$router.currentRoute.path === '/aplicativo-categorias/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativo-categorias/index.vue